import type { Language } from '@/lib/types/language';

/**
 * Convert Language array to SelectItem format
 * Returns array of objects with value and label
 */
export function languagesToSelectItems(languages: Language[]) {
  return languages.map((lang) => ({
    value: lang.code,
    label: lang.displayName,
  }));
}

/**
 * Get default hardcoded languages (for fallback when API is not available)
 */
export function getDefaultLanguages(): Language[] {
  return [
    {
      id: '1',
      code: 'fr',
      name: 'Français',
      displayName: '🇫🇷 Français',
      flag: '🇫🇷',
      active: true,
    },
    {
      id: '2',
      code: 'ewe',
      name: 'Ewe',
      displayName: '🇹🇬 Ewe',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '3',
      code: 'mina',
      name: 'Mina',
      displayName: '🇹🇬 Mina',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '4',
      code: 'kabye',
      name: 'Kabyè',
      displayName: '🇹🇬 Kabyè',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '5',
      code: 'kotokoli',
      name: 'Kotokoli',
      displayName: '🇹🇬 Kotokoli',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '6',
      code: 'loso',
      name: 'Loso',
      displayName: '🇹🇬 Loso (Lamba)',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '7',
      code: 'tem',
      name: 'Tem',
      displayName: '🇹🇬 Tem',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '8',
      code: 'bassar',
      name: 'Bassar',
      displayName: '🇹🇬 Bassar',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '9',
      code: 'nawdem',
      name: 'Nawdem',
      displayName: '🇹🇬 Nawdem',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '10',
      code: 'moba',
      name: 'Moba',
      displayName: '🇹🇬 Moba',
      flag: '🇹🇬',
      active: true,
    },
    {
      id: '11',
      code: 'fon',
      name: 'Fon',
      displayName: '🇧🇯 Fon',
      flag: '🇧🇯',
      active: true,
    },
  ];
}
